import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getSavedEmail() {
  return (localStorage.getItem('am_billing_email') || '').trim().toLowerCase() || null;
}

export function setSavedEmail(email) {
  localStorage.setItem('am_billing_email', email.trim().toLowerCase());
}

export async function saveVehicle(email, vehicleId) {
  const { data } = await axios.post(`${API}/watchlist`, { buyer_email: email, vehicle_id: vehicleId });
  return data;
}
export async function unsaveVehicle(email, vehicleId) {
  const { data } = await axios.delete(`${API}/watchlist`, { params: { buyer_email: email, vehicle_id: vehicleId } });
  return data;
}
export async function checkSaved(email, vehicleId) {
  const { data } = await axios.get(`${API}/watchlist/check`, { params: { email, vehicle_id: vehicleId } });
  return data.saved;
}
export async function listWatchlist(email) {
  const { data } = await axios.get(`${API}/watchlist`, { params: { email } });
  return data.items;
}
export async function listNotifications(email, unreadOnly = false) {
  const { data } = await axios.get(`${API}/notifications`, { params: { email, unread_only: unreadOnly } });
  return data; // { notifications, unread_count }
}
export async function markNotificationsRead(email, id = null) {
  const { data } = await axios.post(`${API}/notifications/mark-read`, { email, id });
  return data;
}
export async function updateVehiclePrice(vehicleId, sellerEmail, newPrice) {
  const { data } = await axios.patch(`${API}/vehicles/${vehicleId}`, {
    seller_email: sellerEmail,
    price: newPrice,
  });
  return data;
}
